import {cn} from '@/lib/utils'

interface CountBadgeProps {
    count: number
    variant?: 'destructive' | 'primary' | 'secondary'
    /** Absolutely position the badge over the top-right corner of a relatively-positioned parent. */
    floating?: boolean
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const variantClasses = {
    destructive: 'bg-destructive text-destructive-foreground',
    primary: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
}
/* eslint-enable i18next/no-literal-string */

export function CountBadge({count, variant = 'destructive', floating, className, 'data-testid': testId}: CountBadgeProps) {
    if (count <= 0) return null
    return (
        <span
            className={cn(
                'flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] font-medium',
                variantClasses[variant],
                floating && 'absolute -top-0.5 -right-0.5',
                className,
            )}
            data-testid={testId}
        >
            {count > 99 ? '99+' : count}
        </span>
    )
}
